const skeletonWhite = '#FFF';
const skeletonDarkGrey = '#B7B7B7';
const skeletonLightGrey = '#f3f6f4';
const skeletonTransitionGrey = '#CCC';

export {
    skeletonWhite,
    skeletonDarkGrey,
    skeletonLightGrey,
    skeletonTransitionGrey,
};
